import { render, staticRenderFns } from "./configuratie.html?vue&type=template&id=76ff1cc0&"
import script from "./configuratie.js?vue&type=script&lang=js&"
export * from "./configuratie.js?vue&type=script&lang=js&"
import style0 from "./configuratie.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports